<template>
  <div class="clwtlbindex">
    <el-form :inline="true" :model="serch" class="demo-form-inline">
      <el-form-item label="车辆号：">
        <el-input
          v-model="serch.bicycleNo"
          clearable
          @keyup.enter.native="Problemcars"
          @clear="Problemcars"
          placeholder="请输入车辆号回车查询"
        ></el-input>
      </el-form-item>
      <el-form-item label="区域：">
        <el-select
          v-model="serch.areaGuid"
          clearable
          @change="Problemcars"
          placeholder="请选择区域回车查询"
          disabled
          filterable
        >
          <el-option
            v-for="item in partData"
            :key="item.PartnerAreaGuid"
            :label="item.PartnerAreaName"
            :value="item.PartnerAreaGuid"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="Problemcars">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="exportdata">导出数据</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="useS">批量处理</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="back">返回</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%"
      @selection-change="SelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="100"
        :selectable="selected"
      ></el-table-column>
      <el-table-column type="index" label="序号" align="center" width="100">
      </el-table-column>
      <el-table-column
        prop="BicycleNo"
        label="车辆号"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column prop="Source" align="center" width="140" label="类型">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.Source == 'Fault'
                ? ''
                : scope.row.Source == 'OrderZero'
                ? 'warning'
                : 'danger'
            "
            disable-transitions
          >
            {{
              scope.row.Source == "Fault"
                ? "故障类"
                : scope.row.Source == "OrderZero"
                ? "免单类"
                : "开锁失败类"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="OccurrenceTime"
        label="时间"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        align="center"
        prop="FaultDescription"
        label="类型备注"
      >
        <template slot-scope="scope">
          {{
            scope.row.Source == "Fault"
              ? scope.row.ErrorCodetext.filter((o) => {
                  return o && o.trim();
                }).toString()
              : scope.row.Source == "OrderZero"
              ? scope.row.OrderZeroDescription
              : scope.row.MultipleUnlockFailuresDescription
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="ProcessingStatus"
        align="center"
        width="140"
        label="状态"
      >
        <template slot-scope="scope">
          <span
            :style="
              scope.row.ProcessingStatus == '未处理'
                ? 'color:#e6a23c'
                : 'color:#67c23a'
            "
            >{{ scope.row.ProcessingStatus }}</span
          >
        </template>
      </el-table-column>
      <!-- <el-table-column prop="address" align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="
              scope.row.Source == 'OrderZero' &&
              scope.row.ProcessingStatus == '未处理'
            "
            @click="use(scope.row)"
            type="primary"
            size="small"
          >
            处理
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-table
      :data="tableData"
      id="tabledata"
      stripe
      border
      style="width: 100%; display: none"
      @selection-change="SelectionChange"
    >
      <el-table-column type="index" label="序号" align="center" width="100">
      </el-table-column>
      <el-table-column
        prop="BicycleNo"
        label="车辆号"
        align="center"
        width="200"
      >
      </el-table-column>
      <el-table-column prop="Source" align="center" width="140" label="类型">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.Source == 'Fault'
                ? ''
                : scope.row.Source == 'OrderZero'
                ? 'warning'
                : 'danger'
            "
            disable-transitions
          >
            {{
              scope.row.Source == "Fault"
                ? "故障类"
                : scope.row.Source == "OrderZero"
                ? "免单类"
                : "开锁失败类"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        align="center"
        prop="FaultDescription"
        label="类型备注"
      >
        <template slot-scope="scope">
          {{
            scope.row.Source == "Fault"
              ? scope.row.ErrorCodetext.filter((o) => {
                  return o && o.trim();
                }).toString()
              : scope.row.Source == "OrderZero"
              ? scope.row.OrderZeroDescription
              : scope.row.MultipleUnlockFailuresDescription
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="ProcessingStatus"
        align="center"
        width="140"
        label="状态"
      >
        <template slot-scope="scope">
          <span
            :style="
              scope.row.ProcessingStatus == '未处理'
                ? 'color:#e6a23c'
                : 'color:#67c23a'
            "
            >{{ scope.row.ProcessingStatus }}</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="备注" :visible.sync="dialogVisible" width="30%">
      <el-input
        v-model="useinfo.ProcessingRemarks"
        placeholder="请输入备注"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          :disabled="useinfo.ProcessingRemarks.length <= 0"
          type="primary"
          @click="setbicytype"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Problemcars, getpartnerArea, setbicytype } from "../../api/customer";

import Base64 from "@/utils/base64"; //引入
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  name: "OutBalanceList",
  data() {
    return {
      serch: {
        bicycleNo: "",
        areaGuid: "",
        showSDate: "",
        showEDate: "",
      },
      dialogVisible: false,
      useinfo: {
        lds: [],
        classification: "",
        HandledBy: "",
        ProcessingRemarks: "",
      },
      partData: [],
      tableData: [],
      selected(row, index) {
        if (row.Source == "OrderZero") {
          // 根据你的条件来设置
          return true; //可选择
        } else {
          return false; //不可选择
        }
      },
    };
  },
  async created() {
    const partData = await this.loadPartner();
    this.Problemcars();
  },
  methods: {
    back() {
      this.$router.back();
    },
    // 列表
    Problemcars() {
      this.tableData = [];
      let myLord =
        localStorage.getItem("LoginName") +
        "|" +
        localStorage.getItem("LoginPwd") +
        "|" +
        parseInt(new Date().getTime() / 1000) +
        "|" +
        Math.round(Math.random() * 100) +
        "|" +
        "cg3gdfg%dgcdsxx";
      let base1 = new Base64();
      Problemcars({
        myLord: base1.encode(myLord),
        ...this.serch,
      }).then((res) => {
        if (res.status == "success") {
          const { FaultSet, OrderZeroSet } = res;
          if (FaultSet && FaultSet.length > 0) {
            FaultSet.forEach((o) => {
              if (o.Source == "Fault") {
                let text = [];
                text.push(
                  o.FaultDescription[0] == 0 ? "" : "霍尔故障,",
                  o.FaultDescription[1] == 0 ? "" : "转把故障,",
                  o.FaultDescription[2] == 0 ? "" : "刹车故障,",
                  o.FaultDescription[3] == 0 ? "" : "控制器故障,",
                  o.FaultDescription[4] == 0 ? "" : "电机故障,",
                  o.FaultDescription[5] == 0 ? "" : "电池电压故障(BMS),",
                  o.FaultDescription[6] == 0 ? "" : "蓝牙故障,",
                  o.FaultDescription[7] == 0 ? "" : "BMS故障(无法通讯),",
                  o.FaultDescription[8] == 0 ? "" : "Ecu主控制器固件故障,"
                );

                o.ErrorCodetext = text;
              }
            });
          }

          this.tableData = [...FaultSet, ...OrderZeroSet];
        }
        console.log(this.tableData);
      });
    },
    loadPartner() {
      return new Promise((resolve) => {
        let myLord =
          localStorage.getItem("LoginName") +
          "|" +
          localStorage.getItem("LoginPwd") +
          "|" +
          parseInt(new Date().getTime() / 1000) +
          "|" +
          Math.round(Math.random() * 100) +
          "|" +
          "666六陆sixZZZ/.";
        let base1 = new Base64();
        getpartnerArea({
          myLord: base1.encode(myLord),
          source: "get_effective_area_name_list",
        })
          .then((res) => {
            // console.log(res);
            if (res.status == "success") {
              this.partData = res.data;
              this.serch.areaGuid = this.$route.params.valueAr;
              resolve(true);
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {});
      });
    },
    exportdata() {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector("#tabledata"));
      const itme = this.partData.filter(
        (o) => o.PartnerAreaGuid == this.serch.areaGuid
      )[0];
      console.log(itme);
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          `${itme.PartnerAreaName}问题车辆.xlsx`
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    setbicytype() {
      let myLord =
        localStorage.getItem("LoginName") +
        "|" +
        localStorage.getItem("LoginPwd") +
        "|" +
        parseInt(new Date().getTime() / 1000) +
        "|" +
        Math.round(Math.random() * 100) +
        "|" +
        "dx4352xxaaam";
      let base1 = new Base64();
      setbicytype({
        myLord: base1.encode(myLord),
        classification: this.useinfo.classification,
        HandledBy: this.useinfo.HandledBy,
        ProcessingRemarks: this.useinfo.ProcessingRemarks,
        Ids: this.useinfo.lds.toString(),
      })
        .then((res) => {
          // console.log(res);
          if (res.status == "success") {
            this.dialogVisible = false;
            this.Problemcars();
            this.useinfo.lds = [];
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {});
    },
    use(val) {
      this.useinfo.ProcessingRemarks = "";
      this.useinfo.lds = [];
      this.useinfo.lds.push(val.ID);
      this.useinfo.classification = val.Source;
      this.dialogVisible = true;
    },
    SelectionChange(val) {
      console.log(val);
      val.forEach((o) => {
        this.useinfo.lds.push(o.ID);
      });
      this.useinfo.lds = [...new Set(this.useinfo.lds)];
      this.useinfo.classification = "OrderZero";
    },
    useS() {
      if (this.useinfo.lds.length <= 0) {
        this.$message.error("请选择订单类型数据");
        return false;
      }
      this.useinfo.ProcessingRemarks = "";
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.clwtlbindex {
  padding: 60px 40px;
}
</style>